// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import SweetAlertController from "./sweetalert_controller"
import Select2Controller from "./select2_controller"
import RichEditController from "./rich_edit_controller"
import MenuController from "./menu_controller"
import ToggleIsEnabledController from "./toggle_is_enabled_controller"
import ChangeSeqController from "./change_seq_controller"
import OpenDetailModelController from "./open_detail_model_controller"
import FileController from "./file_controller"


application.register("sweetalert", SweetAlertController)
application.register("select2", Select2Controller)
application.register("editor", RichEditController)
application.register("menu", MenuController)
application.register("toggle-is-enabled", ToggleIsEnabledController)
application.register("change-seq", ChangeSeqController)
application.register("open-detail-model", OpenDetailModelController)
application.register("file", FileController)
